import { render } from "./IconLivestream.vue?vue&type=template&id=0f050ddb"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLivestream.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f050ddb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f050ddb', __exports__)) {
    api.reload('0f050ddb', __exports__)
  }
  
  module.hot.accept("./IconLivestream.vue?vue&type=template&id=0f050ddb", () => {
    api.rerender('0f050ddb', render)
  })

}


export default __exports__